import React, {useContext, useEffect, useState} from "react";
import UserContext from "../components/UserContext";
import Home_1 from "./home/home_1";
import {hasAuthParams, useAuth} from "react-oidc-context";
import {useTheme} from "next-themes";

export default function Home() {
  const { scrollRef } = useContext(UserContext);

  const { theme, setTheme} = useTheme();
  setTheme("dark");

  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  useEffect(() => {
    if (!hasAuthParams() &&
        !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading &&
        !hasTriedSignin
    ) {
      auth.signinRedirect();
      setHasTriedSignin(true);
    }
  }, [auth, hasTriedSignin]);

  
  useEffect(() => {
    window.scrollTo(0, scrollRef.current.scrollPos);
    const handleScrollPos = () => {
      scrollRef.current.scrollPos = window.scrollY;
    };
    window.addEventListener("scroll", handleScrollPos);
    return () => {
      window.removeEventListener("scroll", handleScrollPos);
    };
  });

  return (
    <>
      <Home_1 />
    </>
);
}
